// Shared so SideMenuTemplate, Router and the view itself can't drift on rename.
// SideMenuTemplate cannot import from the view directly (PageTemplate ->
// PrimaryNavigation -> SideMenuTemplate creates a cycle), so these constants
// live in their own module that all three can pull in.
//
// Mirrors the FrDiagnosticsView/constants.ts precedent.
export const CONFIGCAT_FLAG_KEY = 'taggedPhotoReportEnabled'

export const TAGGED_PHOTO_REPORT_PATH = '/tagged-photo-report'
